const config = {
  ENVIRONMENT_NAME: 'prod',
  forwoodId: {
    URL: 'https://id.evolution.forwoodsafety.com',
    USER_TOKEN_URL: 'https://cvijd1u1yl.execute-api.us-west-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://pzd0rjhb8g.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'teams-container-1.11.7',
    HOSTNAME: 'https://teams.evolution.forwoodsafety.com',
    TEAMS_MICROFRONTEND_URL: 'https://teams-service.evolution.forwoodsafety.com',
    TARGETS_MICROFRONTEND_URL: 'https://targets.evolution.forwoodsafety.com',
    TEAMS_ACCESS_ROLE: 'TeamsAccess',
    TEAM_TARGETS_ACCESS_ROLE: 'TeamTargetsAccess',
  },
  configurationService: {
    URL: 'https://config.evolution.forwoodsafety.com',
    WEBSOCKET: 'wss://n85utmo5h5.execute-api.us-west-2.amazonaws.com/prod'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
